import React from 'react';
import { Check } from 'lucide-react';
export function PricingCard() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden max-w-4xl mx-auto mb-8" data-id="element-366">
      <div className="p-8 md:flex items-center gap-8" data-id="element-367">
        <div className="w-full md:w-1/3 flex justify-center mb-6 md:mb-0" data-id="element-368">
          <img src="https://cdn.magicpatterns.com/uploads/tZ5HNHL7yceUkm8W1gJPub/Screenshot_2026-01-08_at_11.02.51_PM.png" alt="Complete Bootcamp Bundle" className="w-full max-w-sm h-auto object-contain" data-id="element-369" />
        </div>
        <div className="w-full md:w-2/3 text-left" data-id="element-370">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-2" data-id="element-371">
            BOOTCAMP BUNDLE
          </h2>
          <div className="flex items-baseline gap-2 mb-4" data-id="element-372">
            <span className="text-xl text-gray-500" data-id="element-373">Solo por</span>
            <span className="text-4xl font-bold text-[#06b6d4]" data-id="element-374">$297</span>
          </div>
          <p className="text-lg text-gray-700 font-medium" data-id="element-375">
            Acceso completo al programa intensivo de 48 Hrs AI Cash Machine.
            Aprende a crear, vender y escalar productos digitales con
            Inteligencia Artificial.
          </p>
        </div>
      </div>
    </div>;
}